// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MLm7","label":"styles_label__2BYnM"};